import type { ModulePage } from './types'

export const sparks: ModulePage = {
  slug: 'sparks',
  name: 'Sparks AI Assistant',
  tagline: 'Your practice’s AI assistant: ask anything, act on everything.',
  icon: 'sparkle',
  colorClass: 'growth',
  pricingModules: ['sparks'],
  featured: true,

  seo: {
    title: 'Sparks AI Assistant',
    description:
      'Sparks is the AI assistant built into WealthSpace. Ask questions about your clients, draft communications, and get real-time suggestions grounded in your own data.',
    keywords:
      'AI assistant financial advisers, adviser copilot, WealthSpace Sparks, AI for IFAs',
  },

  hero: {
    eyebrow: 'Sparks AI Assistant',
    title: 'An AI assistant that',
    titleAccent: 'knows your practice',
    subtitle:
      'Ask Sparks about a client, draft an email, summarise a case, or get a second pair of eyes on your advice, grounded in your firm’s own knowledge and data.',
  },

  useCases: [
    {
      icon: 'sparkle',
      title: 'Ask about any client',
      body: 'Get an instant, grounded answer about a client’s circumstances without digging through files.',
    },
    {
      icon: 'document',
      title: 'Draft on demand',
      body: 'Emails, summaries, meeting prep and follow-ups drafted in seconds, ready for your review.',
    },
    {
      icon: 'shield',
      title: 'Sense-check your thinking',
      body: 'Surface missing information, risks and compliance considerations as a second pair of eyes.',
    },
  ],

  benefits: [
    {
      icon: 'sparkle',
      title: 'Grounded in your data',
      body: 'Answers draw on your clients, documents and knowledge base, not generic internet guesses.',
    },
    {
      icon: 'bolt',
      title: 'Real-time suggestions',
      body: 'Helpful prompts and next steps surface as you work, right where you are.',
    },
    {
      icon: 'users',
      title: 'Works across the platform',
      body: 'From the client record to the report builder, Sparks is one assistant for the whole practice.',
    },
    {
      icon: 'shield',
      title: 'Private by design',
      body: 'Your data stays yours. Sparks operates inside your secure WealthSpace environment.',
    },
  ],

  stats: [
    { value: 'Instant', label: 'answers from your own data' },
    { value: 'Everywhere', label: 'across the platform' },
    { value: '24/7', label: 'always-on assistant' },
  ],

  cta: {
    title: 'Meet your new',
    titleAccent: 'AI assistant',
    subtitle: 'Put Sparks to work on your real client data and see what it can do.',
    note: 'Included from the Professional plan. Start free.',
  },
}
